module.exports = __webpack_public_path__ + "static/media/soc-r.c62128ea.png";